import {
  TransferThemesButton,
  TransferVersesButton,
  ThemeToProductValidationButton,
  LayoutTemplateCopyButton,
  ProductLayoutCopyButton,
  ValidateMessengerProductsToDpsv2Button,
  CreateNewProductButton,
  CreateDefaultLayoutsForProductButton,
} from './'
import { Redirect } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { userAtom } from '@/atoms/_globalAtoms'
import { isSuperAdmin } from '@/hooks/utility/useIsSuperAdmin'
import { Navigation } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import ThemeCopyButton from './ThemeDuplicateButton'

/**
 * The Launch page shows only to super admins: its tools overwrite or create
 * templates for every funeral home. Anyone else is sent to /dashboard, as the
 * admin home and Case Image QC send them. It waits for the user record first,
 * because on a hard load the record arrives after the first render.
 */
export const Launch = () => {
  const user = useRecoilValue(userAtom)

  if (user === null) return null
  if (!isSuperAdmin(user)) return <Redirect to="/dashboard" />

  return (
    <>
      <Navigation type="admin" />
      <Flex center gap="32px" column data-testid="launch-page">
        <Text margin="32px 0 0 0" size="32px" bold>
          🚀 Launch dashboard
        </Text>
        <Flex gap="16px" full wrap="wrap" justify="center">
          <TransferThemesButton />
          <TransferVersesButton />
          <ThemeToProductValidationButton />
          <LayoutTemplateCopyButton />
          <ProductLayoutCopyButton />
          <ValidateMessengerProductsToDpsv2Button />
          <CreateNewProductButton />
          <ThemeCopyButton />
          <CreateDefaultLayoutsForProductButton />
        </Flex>
      </Flex>
    </>
  )
}

export default Launch
